/* eslint-env browser */
/* eslint class-methods-use-this: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BoxComponent from '../components/BoxComponent';
import SearchComponent from '../components/SearchComponent';
import getEducations from '../actions/getEducations';
import '../styles/styles.scss';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      educations: [],
      loaded: props.loaded,
      setFromGlobal: false,
    };

    this.getEducations = this.getEducations.bind(this);
    this.setEducations = this.setEducations.bind(this);
    this.setFromGlobal = this.setFromGlobal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.loaded && nextProps.loaded) {
      return {
        loaded: true,
      };
    }

    return null;
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.getEducations();
  }

  componentDidUpdate() {
    const { loaded, setFromGlobal } = this.state;
    const { isLocal } = this.props;
    if (!setFromGlobal && loaded && isLocal) {
      this.setFromGlobal();
    }
  }

  setEducations(educations) {
    this.setState({ educations });
  }

  getEducations(_query, _associations, _all = null) {
    const {
      educations: pEducations,
    } = this.props;
    const query = _query;
    const associations = _associations;
    let all = _all;

    const newEducations = [];
    if (all === null) {
      all = pEducations.Items;
    }

    all.forEach((edu) => {
      if (edu.Name.toLowerCase().indexOf(query) > -1 || query.length === 0) {
        let count = 0;
        for (let i = 0; i < associations.length; i += 1) {
          if (associations[i] === 0 || edu.Associations.indexOf(associations[i]) > -1) {
            count += 1;
          }
        }
        if (count === associations.length) {
          newEducations.push(edu);
        }
      }
    });

    return newEducations;
  }

  setFromGlobal() {
    const { globalQuery, globalAssociations } = this.props;
    this.setState({
      educations: this.getEducations(globalQuery.toLowerCase(), globalAssociations),
      setFromGlobal: true,
    });
  }

  render() {
    const { educations: sEducations } = this.state;
    const {
      educations: pEducations,
      isLocal,
      emptyEvuLoad,
    } = this.props;
    let mappedEducations = [];
    if (sEducations.length > 0) {
      mappedEducations = sEducations;
    } else if (!emptyEvuLoad) {
      mappedEducations = pEducations.Items;
    }
    const eduElements = mappedEducations.map((edu) => (
      <BoxComponent key={edu.ID} education={edu} />
    ));

    let search = null;

    if (!isLocal) {
      search = (
        <SearchComponent
          educations={pEducations.Items}
          groupings={pEducations.Groupings}
          getEducations={this.getEducations}
          setEducations={this.setEducations}
          educationCount={eduElements.length}
          emptyEvuLoad={emptyEvuLoad}
        />
      );
    }

    return (
      <div className="row">
        <div className="column large-12 medium-12 small-12">
          {search}
          <div className="row evu-educations">
            {eduElements}
          </div>
        </div>
      </div>
    );
  }
}

AppComponent.defaultProps = {
  emptyEvuLoad: false,
  globalQuery: undefined,
  globalAssociations: undefined,
};

AppComponent.propTypes = {
  actions: PropTypes.shape({
    getEducations: PropTypes.func.isRequired,
  }).isRequired,
  educations: PropTypes.shape({
    Groupings: PropTypes.arrayOf(PropTypes.shape({
      Active: PropTypes.bool.isRequired,
      DataListAssociations: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
      GroupOrder: PropTypes.number.isRequired,
      ID: PropTypes.number.isRequired,
      List: PropTypes.number.isRequired,
      Name: PropTypes.string.isRequired,
    }).isRequired).isRequired,
    Items: PropTypes.arrayOf(PropTypes.shape({
      Associations: PropTypes.arrayOf(PropTypes.number.isRequired),
      Description: PropTypes.string,
      ID: PropTypes.number.isRequired,
      Location: PropTypes.string,
      Name: PropTypes.string.isRequired,
      Occurence: PropTypes.string,
      Subject: PropTypes.string,
      Type: PropTypes.string,
      Url: PropTypes.string.isRequired,
    }).isRequired).isRequired,
  }).isRequired,
  loaded: PropTypes.bool.isRequired,
  isLocal: PropTypes.bool.isRequired,
  globalQuery: PropTypes.string,
  globalAssociations: PropTypes.arrayOf(PropTypes.number),
  emptyEvuLoad: PropTypes.bool,
};

function mapStateToProps(state) {
  return state.educations;
}
function mapDispatchToProps(dispatch) {
  const actions = { getEducations };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

AppComponent.displayName = 'AppComponent';
export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);
